<template>
  <v-container class="fill-height" tag="section">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-dialog v-model="dialog" hide-overlay persistent width="600">
          <v-card color="primary" dark>
            <v-card-text>
              <h3 class="text-uppercase text-center white--text mb-2">
                Estamos comprobando su contrato, un momento por favor
              </h3>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-btn @click="com()">comprobar</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { goPanel } from "@/utils/router.js";
export default {
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    com() {
      const id_firma = this.$route.query.signature_id;
      const id_contrato = this.$route.query.contract_id;
      this.$store.dispatch("contratos/comprobarContrato", {
        id_firma: id_firma,
        id_contrato: id_contrato,
      });
    },
  },
  mounted() {
    const id_firma = this.$route.query.signature_id;
    const id_contrato = this.$route.query.contract_id;
    //prueba
    // id_firma = 1111000000;
    // id_contrato = "HLMGeiH9DBMJ2qxoBRGX";
    //http://localhost:8080/comprobarfirma?contract_id=4x0vWXgJcW59OWgE91bg&signature_id=16054743140400000
    console.log(id_firma);
    console.log(id_contrato);
    this.$store
      .dispatch("contratos/comprobarContrato", {
        id_firma: id_firma,
        id_contrato: id_contrato,
      })
      .finally(() => this.$router.push("/login"));
  },
};
</script>
<style scoped>
</style>
